import React from "react";
import LinkItemLink from "./link-item-link.jsx";

export default class LinkItem extends React.Component {
    constructor(props) {
        super(props);

        this.generateContent = this.generateContent.bind(this);
        this.generateLink = this.generateLink.bind(this);
        this.onItemSelected = this.onItemSelected.bind(this);
    }

    generateLink() {
        return <LinkItemLink key={this.props.text} url={this.props.url} text={this.props.text} />;
    }

    generateContent() {
        var content = [this.generateLink()];
        return content;
    }

    onItemSelected(e) {
        if (this.props.onClick)
            this.props.onClick(e, this.props.text, this.props.url);
    }

    render() {
        var icon = this.props.icon? <i className={this.props.icon}></i>: "";
        var content = this.generateContent();
        
        return (
            <li onClick={this.onItemSelected}>
                {icon}
                {content}
            </li>
        );
    }
}